import { render } from "./Loading.vue?vue&type=template&id=1b3fee85&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=1b3fee85&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b3fee85"

export default script